import React from 'react';
import styled from 'styled-components';
import DropdownSelect from 'components/inputs/dropdown/DropdownSelectComponent';
import Placeholder from 'components/inputs/selectComponents/Placeholder';
import getSelectLightStyles from 'components/inputs/dropdown/styles/light';
import { mediaQueries } from 'styles/utils/mediaQueries';

function FilterByDepartureComponent({ colors, options, selectedOptions, onChange }) {
  return (
    <Root>
      <DropdownSelect
        colors={colors}
        styles={getSelectLightStyles(colors)}
        options={options}
        selectedOptions={selectedOptions}
        onChange={onChange}
        config={{
          className: 'adverts-filter-by-departure',
          isSearchable: false,
          isClearable: true,
          components: {
            Placeholder,
          },
        }}
        data={{
          placeholderMessageId: 'selectDeparture',
        }}
      />
    </Root>
  );
}

export default FilterByDepartureComponent;

const Root = styled.div`
  ${mediaQueries.fromAndAbove.tablet`
    width: 250px;
  `}
`;
